import {MeterEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {ObjectMappingDataTableCard} from "../../card/ObjectMappingDataTableCard/ObjectMappingDataTableCard";
import {
  ObjectMeterCheckAssocDataTableCard
} from "../../card/ObjectMeterCheckAssocDataTableCard/ObjectMeterCheckAssocDataTableCard";
import {EntityAnchor} from "../../anchor/EntityAnchor/EntityAnchor";
import { HasAccess } from "../../auth/HasAccess/HasAccess";

export type MeterDetailsProps = {
  meter: MeterEntity
}

export const MeterDetails = (props: MeterDetailsProps) => {
  const {meter} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={6}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.meter.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.type.label", "Type")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {t(meter.type.displayValue.id, meter.type.displayValue.defaultMessage)}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.flowmetertype.label", "Flow Meter Type")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.flowMeterType ? t(meter.flowMeterType.displayValue.id, meter.flowMeterType.displayValue.defaultMessage) : undefined}
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.barcode.label", "QR Code")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.barcode}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.uom.label", "Reading Unit of Measure")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.unitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.freighttype.label", "Reading Freight Type")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.freightTypeId ? <DefaultText value={meter.freightTypeName}/> : undefined}
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.object.label", "Reading")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {meter.objectId ? (
                  <EntityAnchor
                    value={{
                      objectId: meter.objectId,
                      objectName: meter.objectName,
                      objectType: meter.objectType
                    }}
                    icon={{
                      size: 14
                    }}/>
                ) : undefined}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.meter.info.field.usable.label", "Usable")}
              </Text>
              <Text ta="left" c={meter.doNotUse ? "warning" : "dimmed"} fz="xs">
                {meter.doNotUse ? t("common.shared.no", "No") : t("common.shared.yes", "Yes")}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <Grid.Col span={6}>
        <ObjectMeterCheckAssocDataTableCard meter={meter} mb="md"/>
        <HasAccess permissions={["object_mapping_view"]}>
          <ObjectMappingDataTableCard entity={meter}/>
        </HasAccess>
      </Grid.Col>
    </Grid>
  );
};

